export const FIRST_POSSIBLE_DATE = '2000-01-01';
export const LAST_POSSIBLE_DATE = '2178-12-31';
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_START_HOUR = 9;
export const DEFAULT_END_HOUR = 17;
